import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

type TLabelCountBoxProps = {
  width?: number;
  height?: number;
  backgroundColor?: string;
  backgroundColorCount?: string;
  borderColor1?: string;
  borderColor2?: string;
  gradientBorderHeight?: number;
  label?: string;
  countText?: string;
};

export default function LabelCountBox(props: TLabelCountBoxProps) {
  const {
    width = 146,
    height = 56,
    backgroundColor = '#FEDD88',
    backgroundColorCount = '#FFB800',
    borderColor1 = 'rgba(255, 207, 83, 0.55)',
    borderColor2 = 'rgba(255, 153, 0, 0.55)',
    gradientBorderHeight = 60,
    label = 'Nectar\nCount',
    countText = '0',
  } = props;

  return (
    <LinearGradient
      colors={[borderColor1, borderColor2]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[styles.gradientBorder, { height: gradientBorderHeight }]}
    >
      <View style={[styles.card, { backgroundColor, width, height }]}>
        <Text style={styles.label}>{label}</Text>
        <View style={[styles.countBadge, { backgroundColor: backgroundColorCount }]}>
          <Text style={styles.countText}>{countText}</Text>
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    paddingVertical: 5,
    paddingHorizontal: 16,
  },
  label: {
    flex: 1,
    fontFamily: 'Secular One',
    fontWeight: '400',
    fontSize: 14,
    color: '#121212',
  },
  countBadge: {
    borderRadius: 8,
    paddingVertical: 6,
    paddingHorizontal: 14,
  },
  countText: {
    color: '#121212',
    fontWeight: 'bold',
    fontSize: 18,
  },
  gradientBorder: {
    borderRadius: 16,
    padding: -4,
  },
});
